export function submitForm(payload: any, callback: any, openInSameTab: boolean = false) {
  let startedDate = new Date();

  if (openInSameTab && payload?.submitUrl) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'post';
    form.action = payload?.submitUrl;

    const parameters = ['Parameter1', 'Parameter2', 'Parameter3'];
    for (const params of parameters) {
      if (!payload?.hasOwnProperty(params.toLowerCase())) {
        return;
      }
      const input = document.createElement('input');
      input.name = params;
      input.id = params;
      input.value = payload[params.toLowerCase()];
      input.defaultValue = payload[params.toLowerCase()];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    return;
  }

  const popupWinHeight = 650;
  const popupWinWidth = 1200;
  const left = (screen.width - popupWinWidth) / 2;
  const top = (screen.height - popupWinHeight) / 4;
  const windowFeatures =
    `width=${popupWinWidth},height=${popupWinHeight},top=${top},left=${left}` +
    ',resizable=yes,location=yes,scrollbars=yes,status=yes';

  const newWindow = window.open('', '_blank', windowFeatures);
  if (!newWindow) {
    return;
  }

  const form = newWindow.document.createElement('form');
  form.style.display = 'none';
  form.method = 'post';
  form.action = payload?.submitUrl;

  const parameters = ['Parameter1', 'Parameter2', 'Parameter3'];
  for (const params of parameters) {
    if (!payload?.hasOwnProperty(params.toLowerCase())) {
      return;
    }
    const input = newWindow.document.createElement('input');
    input.name = params;
    input.id = params;
    input.value = payload[params.toLowerCase()];
    input.defaultValue = payload[params.toLowerCase()];
    form.appendChild(input);
  }

  newWindow.document.body.appendChild(form);
  form.submit();

  const interval = setInterval(() => {
    try {
      timeInterval(newWindow, startedDate, interval, callback);
    } catch (ex) {
      console.error('Failed:', ex);
      if (newWindow?.closed || !newWindow) {
        callback({ message: 'Closing window timeout!' });
        clearInterval(interval);
      }
    }
  }, 2000);
}

export function timeInterval(newWindow: any, startedDate: Date, interval: any, callback: any) {
  const diffMilliSeconds = new Date().valueOf() - startedDate.valueOf();

  if (newWindow?.location?.host === location.host) {
    const params = new URL(newWindow.location.href).searchParams;
    callback(null, params.get('id'));
    newWindow.close();
    clearInterval(interval);
  }

  if ((diffMilliSeconds / (1000 * 60 * 15) > 1 && newWindow) || !newWindow) {
    newWindow?.close();
    callback({ message: 'Closing window timeout!' });
    clearInterval(interval);
  }
}
